export default __webpack_public_path__ + "static/media/heart.8db5a767.svg";